import {colors, ThemeProvider as MUIThemeProvider} from '@mui/material'
import {createTheme, Theme as MUITheme} from '@mui/material/styles'
import {TypographyOptions} from '@mui/material/styles/createTypography'
import {isStagingEnvironment} from '../common/environment/environmentManager'

const typography: TypographyOptions = {
  h1: {
    fontWeight: 500,
    fontSize: 35,
    letterSpacing: '-0.24px',
  },
  h2: {
    fontWeight: 500,
    fontSize: 29,
    letterSpacing: '-0.24px',
  },
  h3: {
    fontWeight: 500,
    fontSize: 24,
    letterSpacing: '-0.06px',
  },
  h4: {
    fontWeight: 500,
    fontSize: 20,
    letterSpacing: '-0.06px',
  },
  h5: {
    fontWeight: 500,
    fontSize: 16,
    letterSpacing: '-0.05px',
  },
  h6: {
    fontWeight: 500,
    fontSize: 14,
    letterSpacing: '-0.05px',
  },
  overline: {
    fontWeight: 500,
  },
}

const primaryMainColor = isStagingEnvironment() ? '#7D20B3' : '#014F59'
const secondaryTextColor = isStagingEnvironment() ? '#7D20B3' : '#014F59'

export const theme: Theme = createTheme({
  palette: {
    background: {
      default: colors.common.white,
      paper: colors.common.white,
    },
    primary: {
      main: primaryMainColor,
    },
    secondary: {
      main: '#07A37B',
    },
    text: {
      primary: '#001719',
      secondary: secondaryTextColor,
    },
  },
  typography,
})

export type Theme = MUITheme
export const ThemeProvider = MUIThemeProvider
